module.exports = __webpack_public_path__ + "static/media/icon3.2cdcf558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon3.jpg
// module id = 131
// module chunks = 0